import cx from "classnames";
import type { Element } from "React";
import "./IconBetDrawerEmpty.scss";
type Props = {
  className?: string;
};

const IconBetDrawerEmpty = (props: Props): Element<"svg"> => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 68 68"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={cx(props.className, "icon__icon-bet-drawer-empty")}
  >
    <title>Empty Bet Drawer</title>
    <g>
      <g>
        <g>
          <path
            d="M45.5468334,7.57697572 C44.9969557,8.93854759 44.6952997,10.4326571 44.6952997,12 C44.6952997,18.3512746 49.6487254,23.5 56,23.5 C57.5801875,23.5 59.0859363,23.1812904 60.4564723,22.6046454 C60.5314999,22.680267 60.5710393,22.7201193 60.5710393,22.7201193 C62.4505195,26.7558755 63.5,31.2557214 63.5,36 C63.5,53.397 49.397,67.5 32,67.5 C14.603,67.5 0.5,53.397 0.5,36 C0.5,18.603 14.6045679,4.5 32,4.5 C36.8329652,4.5 41.4119109,5.58894477 45.5049325,7.53474313 C45.5049325,7.53474313 45.5191918,7.54911531 45.546833,7.57697536 L45.5468334,7.57697572 Z"
            id="Combined-Shape"
          />
          <path
            d="M56,23.5 C62.3512746,23.5 67.5,18.3512746 67.5,12 C67.5,5.64872538 62.3512746,0.5 56,0.5 C49.6487254,0.5 44.6952997,5.64872538 44.6952997,12 C44.6952997,18.3512746 49.6487254,23.5 56,23.5 Z"
            id="Oval"
          />
          <g id="zero" transform="translate(52.000000, 7.000000)">
            <g>
              <path
                d="M3.78710938,0.2109375 C5.05404279,0.2109375 5.97004926,0.732742178 6.53515625,1.77636719 C6.97265844,2.58301185 7.19140625,3.68814402 7.19140625,5.09179688 C7.19140625,6.4225327 6.99316604,7.52310763 6.59667969,8.39355469 C6.02245807,9.64225885 5.08366537,10.2666016 3.78027344,10.2666016 C2.60448631,10.2666016 1.72949506,9.75619 1.15527344,8.73535156 C0.67675542,7.88313376 0.4375,6.73926499 0.4375,5.30371094 C0.4375,4.19172621 0.581053252,3.23698315 0.868164062,2.43945312 C1.40592717,0.953768613 2.37889921,0.2109375 3.78710938,0.2109375 Z M3.7734375,9.14550781 C4.41146152,9.14550781 4.91959446,8.86295855 5.29785156,8.29785156 C5.67610866,7.73274457 5.86523438,6.68002072 5.86523438,5.13964844 C5.86523438,4.02766371 5.72851699,3.11279656 5.45507812,2.39501953 C5.18163926,1.6772425 4.65072009,1.31835938 3.86230469,1.31835938 C3.13769169,1.31835938 2.60791183,1.65901352 2.27294922,2.34033203 C1.93798661,3.02165054 1.77050781,4.02538399 1.77050781,5.3515625 C1.77050781,6.34961437 1.8776031,7.15168968 2.09179688,7.7578125 C2.41992352,8.68294733 2.98046479,9.14550781 3.7734375,9.14550781 Z"
                id="0"
              />
            </g>
          </g>
        </g>
        <g transform="translate(17.000000, 22.000000)">
          <path
            d="M15,1.315 L2.104,9 L15,16.685 L27.896,9 L15,1.315 Z M15,0.151 L29.85,9 L15,17.85 L0.15,9 L15,0.15 L15,0.151 Z"
            id="Shape"
          />
          <path
            d="M15.512,21.99 L14.488,21.99 L15,21.685 L15.512,21.99 Z M27.896,14 L29.849,14 L15,22.85 L0.15,14 L2.104,14 L15,21.685 L27.896,14 Z M15.512,21.99 L14.488,21.99 L15,21.685 L15.512,21.99 Z M27.896,14 L29.849,14 L15,22.85 L0.15,14 L2.104,14 L15,21.685 L27.896,14 Z"
            id="Shape"
          />
          <path
            d="M15.512,26.99 L14.488,26.99 L15,26.685 L15.512,26.99 Z M27.896,19 L29.849,19 L15,27.85 L0.15,19 L2.104,19 L15,26.685 L27.896,19 Z M15.512,26.99 L14.488,26.99 L15,26.685 L15.512,26.99 Z M15,26.685 L27.896,19 L29.849,19 L15,27.85 L0.15,19 L2.104,19 L15,26.685 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconBetDrawerEmpty;
